import { supabase } from "@/lib/supabase";

/**
 * Organizer-side view of mutual matches for an event. Drives the
 * dashboard Matches tab where the organizer can manually accelerate
 * a not-yet-revealed match — TZ block D items 9, 15.
 */
export interface OrganizerMatchRow {
  match_id: string;
  a_id: string;
  a_name: string;
  a_video_storage_path: string | null;
  b_id: string;
  b_name: string;
  b_video_storage_path: string | null;
  manually_revealed_at: string | null;
  created_at: string;
}

export async function fetchEventMatchesForOrganizer(
  eventId: string,
): Promise<OrganizerMatchRow[]> {
  const { data, error } = await supabase.rpc(
    "find_event_matches_for_organizer",
    { p_event_id: eventId },
  );
  if (error) throw new Error(error.message);
  return (data ?? []) as OrganizerMatchRow[];
}

/**
 * Pop a single match out of the event-wide reveal timer. Idempotent —
 * re-calling does not change the original manually_revealed_at value.
 * Returns the moment the override was first applied.
 */
export async function revealMatchManually(matchId: string): Promise<string> {
  const { data, error } = await supabase.rpc("reveal_match_manually", {
    p_match_id: matchId,
  });
  if (error) throw new Error(error.message);
  return data as string;
}
